import {
  parsePhoneForApi,
  toE164FromLocalDigits,
  validatePhoneValue,
} from "@/utils/phoneInput";
import { isIndianUser } from "@/utils/getCountryCode";

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function parseCredentialInput(value = "") {
  const trimmed = String(value).trim();

  if (!trimmed) {
    return { valid: false, error: "Email ID or phone number is required" };
  }

  if (trimmed.includes("@")) {
    if (!EMAIL_PATTERN.test(trimmed)) {
      return { valid: false, error: "Enter a valid email address" };
    }

    return {
      valid: true,
      emailId: trimmed,
      countryCode: "",
      mobileNumber: "",
      channelLabel: "Email",
    };
  }

  const normalizedPhone = trimmed.startsWith("+")
    ? trimmed
    : toE164FromLocalDigits(
        trimmed.replace(/\D/g, ""),
        isIndianUser() ? "IN" : "AE"
      );

  const phoneError = validatePhoneValue(normalizedPhone);
  if (phoneError) {
    return { valid: false, error: phoneError };
  }

  const parsedPhone = parsePhoneForApi(normalizedPhone);
  if (!parsedPhone?.phoneNo) {
    return { valid: false, error: "Enter a valid phone number" };
  }

  return {
    valid: true,
    emailId: "",
    countryCode: parsedPhone.countryCode,
    mobileNumber: parsedPhone.phoneNo,
    channelLabel: "Phone",
  };
}

export function buildAuthRequestPayload(credentials = {}) {
  return {
    emailId: credentials.emailId || "",
    countryCode: credentials.countryCode || "",
    mobileNumber: credentials.mobileNumber || "",
    requestFrom: "Web",
  };
}

export function isAuthSuccess(response) {
  const status = String(response?.status || "").toLowerCase();
  return status === "success" || status === "true";
}

export function parseAuthSession(response) {
  const payload = response?.data ?? response ?? {};

  if (typeof payload === "string") {
    return { token: payload, userId: "" };
  }

  const sessionExpireDateTime = String(
    payload.sessionExpireDateTime ??
      payload.SessionExpireDateTime ??
      ""
  ).trim();

  return {
    token:
      payload.token ||
      payload.Token ||
      payload.accessToken ||
      payload.access_token ||
      "",
    userId: String(
      payload.userId ||
        payload.UserId ||
        payload.user_id ||
        payload.id ||
        ""
    ),
    sessionExpireDateTime,
  };
}

export function getAuthErrorMessage(error, fallback = "Something went wrong.") {
  return (
    error?.response?.data?.message ||
    error?.response?.data?.Message ||
    error?.message ||
    fallback
  );
}
